.root {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: var(--rec-color-warning);
  border: 1px solid var(--rec-color-warning-border);
  border-radius: 10px;
  text-align: left;
  cursor: pointer;
  font: inherit;
}

.icon {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 11px;
  background: var(--rec-color-warning-border);
  color: var(--rec-color-warning-fg);
}

.label {
  flex: 1;
  min-width: 0;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--rec-color-warning-fg);
}

.count {
  flex: none;
  padding: 3px 7px;
  border-radius: 4px;
  background: var(--rec-color-background);
  color: var(--rec-color-warning-fg);
  font-size: 9px;
  font-weight: 700;
}
